function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#27A7E0",
  d: "M7.5 0a7.5 7.5 0 110 15 7.5 7.5 0 010-15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M8.256 6.72v4.668H6.609V6.72h1.647zM6.5 4.928c0-.127.024-.247.073-.36a.944.944 0 01.496-.495A.896.896 0 017.428 4c.127 0 .247.024.36.073a.944.944 0 01.495.496.896.896 0 01.073.359.896.896 0 01-.073.36.944.944 0 01-.496.495.896.896 0 01-.359.073.896.896 0 01-.36-.073.944.944 0 01-.495-.496.896.896 0 01-.073-.359z"
}));

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/info.0fde2162.svg";
export { SvgInfo as ReactComponent };